var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.internalValue == 1)?_c('span',{staticClass:"label published"},[_vm._v("Publié")]):_vm._e(),_vm._v(" "),(_vm.internalValue == 0)?_c('span',{staticClass:"label unpublished"},[_vm._v("non publié")]):_vm._e(),_vm._v(" "),(_vm.internalValue == -1)?_c('span',{staticClass:"label expired"},[_vm._v("expiré")]):_vm._e(),_vm._v(" "),(_vm.internalValue == 2)?_c('span',{staticClass:"label soon"},[_vm._v("Bientot")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9003ae12","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Published.vue
// module id = 329
// module chunks = 0